var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"programming-languages"},_vm._l((_vm.languages),function(language){return _c('span',{staticClass:"badge badge-pill mr-2",class:_vm.badgeColor(language)},[_vm._v(_vm._s(language))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }